import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

const MetaAdsDashboard = () => import('./MetaAdsDashboard.vue');

const commonMeta = {
  featureFlag: FEATURE_FLAGS.COMPANIES,
  permissions: ['administrator', 'agent'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/meta-ads'),
    component: MetaAdsDashboard,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'meta_ads_dashboard',
        component: MetaAdsDashboard,
        meta: commonMeta,
      },
    ],
  },
];
